
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/india/products/pdp",
      function () {
        return require("private-next-pages/india/products/pdp.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/india/products/pdp"])
      });
    }
  